<template>   
<el-dialog :visible.sync="visible" lock-scroll width="900px" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">     
<div class="login-box">       <span class="login-close"><i class="el-icon-close" @click="close"></i></span>       
<div class="login-logo">         <img src="../../assets/images/temp/logo_new.png" alt="" />       
</div>       
<div class="login-input">         
<el-tabs v-if="status === 'login'" v-model="activeName" class="login-tab">                    
<el-tab-pane name="pwd" label="密码登录"><Pwd :login-type="1" @success="close" @switch="changeType" />
</el-tab-pane>           
<el-tab-pane label="">
</el-tab-pane>           
<el-tab-pane name="code" label="验证码登录"><Pwd :login-type="0" @success="checkPwd" />
</el-tab-pane>         
</el-tabs>         <Forget v-else-if="status === 'forget'" @switch="changeType" />         <Binding v-else @switch="changeType" />         
<div v-if="status === 'login'" class="login-tips">           未注册手机验证后自动登录，注册即代表同意<span @click="goTo('userAgreement')">《用户协议》</span> 和<span @click="goTo('privacyPolicy')">《隐私政策》</span>         
</div>       
</div>     
</div>   
</el-dialog> </template>

<script>
import Pwd from './components/pwd.vue'
import Forget from './components/forget.vue'
import Binding from './components/binding.vue'
import { Message } from 'element-ui'
export default {
  components: {
    Pwd,
    Forget,
    Binding
  },
  data() {
    return {
      activeName: 'pwd',
      status: 'login'
    }
  },
  computed: {
    visible() {
      return this.$store.state.user.visible
    }
  },
  methods: {
    close() {
      this.$store.dispatch('openLogin', false)
    },
    checkPwd(val) {
      if (!val.password) {
        // this.status = 'binging'
        this.close()
      } else {
        this.close()
      }
    },
    changeType(val) {
      this.status = val
    },
    goTo(key) {
      // this.close()
      const id = this.$store.state.app.toolbar[key]
      // this.$router.push(`blog-detail?id=${id}`)
      const list = this.$store.state.user.link
      const item = list.filter((item) => item.contentIdList && item.contentIdList[0] && item.contentIdList[0] === id)[0]
      if (!item) {
        Message({ message: `未获取到${key ==='userAgreement' ? '用户协议' : '隐私政策'}`, type: 'error' })
        return
      }
      // this.$router.push(`blog-detail?id=${id}`)
      const { href } = this.$router.resolve({
        path: `blog-detail?menuId=${item.menuId}&contentType=${item.contentType}&parentId=${item.parentId}&menuName=${item.menuName}`
      });
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-box {
  display: flex;
  position: relative;
  user-select: none;
  margin: auto;
  width: 900px;
  height: 523px;
  padding: 72px 0;
  margin-top: 170px;
  .login-close {
    position: absolute;
    right: -7px;
    top: -50px;
    color: white;
    font-size: 33px;
    z-index: 66666;
    i {
      cursor: pointer;
    }
  }
  .login-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 388px;
    border-right: 1px solid #d8d8d8;
    img {
      width: 175px;
      height: 188px;
      margin-bottom: 35px;
    }
    span {
      color: #333333;
    }
    span:nth-child(2) {
      font-size: 35px;
      letter-spacing: 0;
      font-weight: 500;
    }
    span:nth-child(3) {
      font-size: 23px;
      letter-spacing: 8px;
      line-height: 32px;
      font-weight: 400;
    }
  }
  .login-input {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
    .login-tab {
      width: 287px;
      margin-bottom: 14px;
      box-shadow: none;
      border: none;
      height: 100%;
      ::v-deep .el-tabs__header {
        .el-tabs__nav-wrap::after {
          background: transparent;
        }
        .el-tabs__nav {
          width: 100%;
          .el-tabs__active-bar {
            background: var(--color);
            height: 1px;
          }
          > div {
            width: auto;
            padding: 0;
            user-select: none;
            text-align: center;
            font-size: 24px;
            color: #666666;
            font-weight: 400;
          }
          > div:nth-child(3) {
            position: relative;
            width: 20%;
            pointer-events: none;
            &::after {
              position: absolute;
              content: '';
              top: calc(50% + 3px);
              width: 1px;
              height: 19px;
              background: #d8d8d8;
            }
          }
          .is-active {
            color: #333333;
            font-weight: 600;
          }
        }
      }
    }
    .login-tips {
      width: 287px;
      font-size: 12px;
      color: #cccccc;
      letter-spacing: 0;
      font-weight: 400;
      span {
        cursor: pointer;
        color: var(--color);
      }
    }
  }
}
::v-deep .el-dialog {
  border-radius: 0;
  margin-top: 20vh !important;
  margin-bottom: 0;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
